<!--
 * @Author: DY
 * @Date: 2025-02-17 16:19:26
 * @LastEditTime: 2025-02-21 17:24:17
 * @Description: 超期解锁确认【技术质量管理】
 * @FilePath: \ShiMo_Mobile\src\views\sales\overdueUnlockingConfirm\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="overdueUnlockingConfirm commonListStyles">
            <HeaderNav header-title="超期解锁确认" left-icon-name="2" :extr="{ leftCallBack: onClickLeft }"></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">超期解锁申请单号：{{ item.batch_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_str }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>申请人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>申请解锁数量：{{ item.apply_count }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_10@2x.png" alt="">
                                            <span>申请说明：{{ item.apply_remark }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>审核人：{{ item.check_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>实际解锁数量：{{ item.check_count }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>制单时间：{{ item.creation_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="primary" v-if="[1].includes(item.status)" @click="openForm(item, 'edit')">
                                            办理
                                        </van-button>
                                        <van-button plain type="danger" v-else @click="openForm(item, 'view')">
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'overdue-unlocking-confirm',
    mixins: [mixin_list],
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'overdue-unlocking-confirm');
        }
        next();
    },
    data() {
        return {
            tableCode: 'overdue_unlock_confirm',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        openForm(item, type) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'overdueUnlockingConfirmForm',
                params: {
                    id: item?.id ?? null,
                    type,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.overdueUnlockingConfirm
    width 100%
    height 100%
    background #F0F0F0
    .content
        width 100%
        height calc(100% - 44rpx)
        >>>.van-search
            background #EAEAEA !important
            height 45rpx !important
        >>>.van-search__content
            background #fff !important
</style>
